module.exports = __webpack_public_path__ + "static/media/tutor-Bimg2.c184a8cf.jpg";